<template>
  <TableData class="flex-col justify-center">
    <Skeleton class="h-2 w-3/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-5/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-4/6 rounded mb-2xs" />
  </TableData>
  <TableData class="flex-col justify-center">
    <Skeleton class="h-2 w-3/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-2/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-1/6 rounded mb-2xs" />
  </TableData>
  <TableData class="flex-col justify-end">
    <Skeleton class="h-2 w-3/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-5/6 rounded mb-2xs" />
    <Skeleton class="h-2 w-2/6 rounded mb-2xs" />
  </TableData>
  <TableData class="justify-end">
    <Skeleton class="h-32 w-24 rounded" />
  </TableData>
  <TableData class="justify-end self-start">
    <Skeleton class="h-9 w-8 rounded" />
  </TableData>
</template>
